import d from "./DOM.js";
import AccountManager from "./accountManager.js";

export default class RiskCalculator {
	public static init() {
		const btn = d.qs('#open-risk-calc');
		if (btn) {
			d.e('click', () => RiskCalculator.open(), btn);
		}
	}

	public static open() {
		const currentBalance = AccountManager.currentAccount?.balance || 10000;
		const cachedRisk = localStorage.getItem('risk-percent') || '1';

		const modalHtml = `
			<div id="risk-modal" class="modal">
				<div class="modal-content" style="max-width: 400px;">
					<div class="modal-header">
						<h3>Risk & Position Size Calculator</h3>
						<button class="close-modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label>Account Balance ($)</label>
							<input type="number" id="risk-balance" class="form-control" value="${currentBalance.toFixed(2)}">
						</div>
						<div class="form-group">
							<label>Risk Percentage (%)</label>
							<input type="number" id="risk-percent" class="form-control" value="${cachedRisk}" step="0.1">
						</div>
						<div class="fr g10">
							<div class="form-group f1">
								<label>Entry Price</label>
								<input type="number" id="risk-entry" class="form-control" value="1.08500" step="0.00001">
							</div>
							<div class="form-group f1">
								<label>Stop Loss Price</label>
								<input type="number" id="risk-sl-price" class="form-control" value="1.08300" step="0.00001">
							</div>
						</div>
						<div class="form-group">
							<label>Pair Type</label>
							<select id="risk-pair-type" class="form-control">
								<option value="10">Standard (e.g. EURUSD)</option>
								<option value="1000">JPY Pairs (e.g. USDJPY)</option>
								<option value="1">Gold / Indices</option>
							</select>
						</div>
						<hr style="border: 0; border-top: 1px solid var(--theme-border-subtle); margin: 20px 0;">
						<div id="risk-results" style="background: var(--theme-bg-input); padding: 15px; border-radius: 8px;">
							<div class="fr spaceBetween">
								<span>Pips at Risk:</span>
								<span id="res-pips" style="font-weight: bold; color: var(--theme-text-primary);">20.0</span>
							</div>
							<div class="fr spaceBetween" style="margin-top: 10px;">
								<span>Amount to Risk:</span>
								<span id="res-amount" style="font-weight: bold; color: var(--theme-status-loss);">$100.00</span>
							</div>
							<div class="fr spaceBetween" style="margin-top: 10px;">
								<span>Position Size (Lots):</span>
								<span id="res-lots" style="font-weight: bold; color: var(--theme-accent-primary); font-size: 1.2em;">0.50</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		`;

		const wrapper = document.createElement('div');
		wrapper.innerHTML = modalHtml;
		const modal = wrapper.firstElementChild as HTMLElement;
		document.body.appendChild(modal);

		setTimeout(() => modal.classList.add('open'), 10);

		const inputs = ['#risk-balance', '#risk-percent', '#risk-entry', '#risk-sl-price', '#risk-pair-type'];
		inputs.forEach(id => {
			d.e('input', (e) => {
				if (id === '#risk-percent') {
					localStorage.setItem('risk-percent', (e.target as HTMLInputElement).value);
				}
				RiskCalculator.calculate();
			}, d.qs(id));
		});

		d.e('click', () => {
			modal.classList.remove('open');
			setTimeout(() => modal.remove(), 300);
		}, d.qs('.close-modal', modal));

		RiskCalculator.calculate();
	}

	private static calculate() {
		const balance = parseFloat(d.qs<HTMLInputElement>('#risk-balance').value) || 0;
		const percent = parseFloat(d.qs<HTMLInputElement>('#risk-percent').value) || 0;
		const entry = parseFloat(d.qs<HTMLInputElement>('#risk-entry').value) || 0;
		const slPrice = parseFloat(d.qs<HTMLInputElement>('#risk-sl-price').value) || 0;
		const pipValueFactor = parseFloat(d.qs<HTMLSelectElement>('#risk-pair-type').value) || 10;

		const priceDiff = Math.abs(entry - slPrice);
		
		// Simple pip calculation logic
		// Standard: 1.08500 - 1.08300 = 0.00200 -> 20 pips (Factor 10000)
		// JPY: 150.00 - 149.50 = 0.50 -> 50 pips (Factor 100)
		// Gold: 2000 - 1995 = 5.0 -> 5 points/pips (Factor 1)
		let pips = 0;
		if (pipValueFactor === 10) pips = priceDiff * 10000;
		else if (pipValueFactor === 1000) pips = priceDiff * 100;
		else pips = priceDiff;

		const amountToRisk = balance * (percent / 100);
		const lots = pips > 0 ? amountToRisk / (pips * (pipValueFactor / 1)) : 0;

		d.qs('#res-pips').innerText = pips.toFixed(1);
		d.qs('#res-amount').innerText = `$${amountToRisk.toFixed(2)}`;
		d.qs('#res-lots').innerText = isFinite(lots) ? lots.toFixed(2) : "0.00";
	}
}
